<template>
  <div class="subject">
    <div class="form">
      <el-form ref="formCustom" :model="formCustom" class="formCustom" label-width="150px" status-icon>
        <el-form-item label="行业类型：" prop="industryType">
          <el-select v-model="formCustom.industryType" :disabled="true" style="width: 400px;">
            <el-option v-for="(item, index) in industryTypeList" :key="index + 'type'" :label="item.itemText"
                       :value="item.itemValue"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="企业名称：" prop="companyName">
          <el-input v-model="formCustom.companyName" :disabled="true" autocomplete="off" class="input"></el-input>
        </el-form-item>
        <el-form-item label="统一社会信用代码：" prop="organizationCode">
          <el-input v-model="formCustom.organizationCode" :disabled="true" autocomplete="off" class="input"></el-input>
        </el-form-item>
        <el-form-item label="法人姓名：" prop="owner">
          <el-input v-model="formCustom.owner" :disabled="true" autocomplete="off" class="input"></el-input>
        </el-form-item>
        <el-form-item label="企业注册地：" prop="countyCode">
          <el-cascader v-model="formCustom.countyCode" :disabled="true" :options="areaData" :props="props"
                       filterable style="width: 400px;"></el-cascader>
        </el-form-item>
        <el-form-item label="企业规模：" prop="companyScale">
          <el-select v-model="formCustom.companyScale" :disabled="true" style="width: 400px;">
            <el-option v-for="(item, index) in companyScaleList" :key="index + 'type'" :label="item.itemText"
                       :value="item.itemValue"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="营业执照：" prop="businesslicenseCodeUrl">
          <el-upload :action="upAction" :file-list="fileList" :headers="getToken" :limit="1"
                     :on-error="error" :on-exceed="handleExceed" :on-success="success"
                     accept=" .jpg, .jpeg, .png, .bmp, .pdf"
                     class="upload-demo" multiple>
          </el-upload>
        </el-form-item>
        <el-form-item v-if="formCustom.approvalIdea" prop="approvalIdea">
          <template slot="label">
            <div style="color: red;">审批意见：</div>
          </template>
          <el-input v-model="formCustom.approvalIdea" :disabled="true" :rows="4" style="width: 400px;"
                    type="textarea"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button :loading="submitLoading" class="next" type="primary" @click="submitForm('formCustom')">关闭
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {allDivisionTree} from '@/api/public'
import {companyScaleList, industryTypeList} from '@/api/authority'
import {companyDetail} from '@/api/organization'

export default {
  name: "companyApprovalDetail",
  props: {
    row: {
      // 定义接收的类型 还可以定义多种类型 [String, Undefined, Number]
      // 如果required为true,尽量type允许undefined类型，因为传递过来的参数是异步的。或者设置默认值。
      type: Object,
      // 定义是否必须传
      required: true,
      // 定义默认值
      default: {}
    }
  },
  data() {
    return {
      formCustom: {
        industryType: "",
        companyName: "",
        organizationCode: "",
        owner: "",
        countyCode: "",
        companyScale: ""
      },
      areaData: [],
      companyScaleList: [],
      industryTypeList: [],
      fileList: [],
      getToken: {Authorization: 'Bearer ' + localStorage.getToken},
      upAction: this.$getImg + 'api/auth/img',
      props: {value: 'id'},
      submitLoading: false
    };
  },
  mounted() {
    this.init()
  },
  methods: {
    // 初始化
    init() {
      companyDetail(this.row.companyId).then((res) => {
        this.formCustom = res.data.data
        this.formCustom.industryType = res.data.data.industryType.toString()
        this.formCustom.companyScale = res.data.data.companyScale.toString()
      })
      allDivisionTree().then((response) => {
        this.areaData = response.data.data
        this.forAreaData(this.areaData)
      })
      industryTypeList().then((response) => {
        this.industryTypeList = response.data.data
      })
      companyScaleList().then((response) => {
        this.companyScaleList = response.data.data
      })
      this.fileList.push({
        data: this.row.businesslicenseCodeUrl,
        name: this.row.businesslicenseCodeUrl
      })
    },
    forAreaData(v) {
      v.forEach((s) => {
        if (s.children.length == 0) {
          Reflect.deleteProperty(s, 'children')

        } else {
          this.forAreaData(s.children)
        }
      })
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    success(response, file, fileList) {
      this.fileList = fileList
    },
    error(err) {
      console.log(err)
    },
    submitForm(formName) {
      this.$emit('detailSuccess')
    }
  }
}
</script>

<style lang="less" scoped>
.subject {
  .select {
    display: flex;
    flex-direction: column;
    align-items: center;

    .box-card {
      margin-top: 80px;
      text-align: left;
      width: 700px;

      .h {
        font-size: 24px;
        margin-bottom: 10px;
      }

      .item {
        font-size: 16px;
      }
    }
  }

  .form {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .next {
      border-radius: 4px;
      background-color: rgba(0, 123, 211, 1);
      color: rgba(255, 255, 255, 1);
      font-size: 18px;
      height: 50px;
      border-color: #3a62d7;
      width: 300px;
    }

    .formCustom {
      margin-left: 30px;

      .input {
        width: 400px;
      }
    }

    .back {
      cursor: pointer;
      width: 376px;
      color: rgba(16, 16, 16, 1);
      font-size: 16px;
      text-align: left;

      i {
        border: 3px solid black;
        border-width: 0px 1px 1px 0px;
        display: inline-block;
        padding: 5px;
      }

      .left {
        transform: rotate(135deg);
        -webkit-transform: rotate(135deg);
      }
    }
  }
}
</style>
